<template>
  <div class="mt10">
    <a-upload
      list-type="picture-card"
      class="avatar-uploader"
      :maxCount="1"
      :beforeUpload="beforeUpload"
      :showUploadList="false"
      :disabled="disabled"
    >
      <div :class="{ 'img-wrapper': isDelete }" v-if="imageUrl || defaultUrl">
        <img
          v-if="imageUrl || defaultUrl"
          :src="imageUrl || defaultUrl"
          alt="avatar"
          width="100"
          height="100"
          style="object-fit: cover;"
        />
        <div :class="{ 'hover-img': isDelete }" v-if="isDelete">
          <DeleteOutlined style="color: #FFF;" @click.stop="delImg" />
        </div>
      </div>

      <div v-else>
        <loading-outlined v-if="loading"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
    <!-- <div class="msg">
      1.尺寸限制为{{ bannerItem.width }}*{{ bannerItem.height }}
    </div> -->
    <div class="msg">
      2:图片上传大小限制为
      <template v-if="bannerItem.size">
        {{ bannerItem.size * 1000 }}
      </template>
      KB,格式为JPG、PNG、GIF
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, watch } from 'vue'
import {
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
export default {
  components: {
    PlusOutlined,
    LoadingOutlined,
    DeleteOutlined
  },
  emits: ['addImg', 'removeImg'],
  props: [
    'bannerItem',
    'defaultUrl',
    'disabled',
    'isDelete'
    // {
    //   isDelete: { type: Boolean, default: () => false }
    // }
  ],
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      loading: false,
      imageUrl: props.defaultUrl || props.bannerItem.defaultUrl
    })
    console.log(props.defaultUrl)
    // const isSizeList = (file, proportion) => {
    //   return new Promise((resolve, reject) => {
    //     let _URL = window.URL || window.webkitURL
    //     let img = new Image()
    //     img.onload = () => {
    //       let valid = img.width / img.height === proportion
    //       valid ? resolve(true) : reject(false)
    //     }
    //     img.src = _URL.createObjectURL(file)
    //   })
    // }
    const handleUpload = async file => {
      const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
      const { success, data } = await formRequest(api, {
        file
      })
      // file_upload_post({ uploadFile: file })
      if (success) {
        console.log('data ', data)
        state.imageUrl = data.url
        emit('addImg', data.url)
      }
    }
    const beforeUpload = async file => {
      const isJpgOrPng =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      if (!isJpgOrPng) {
        return message.error('请上传格式为JPG、PNG、GIF的图片')
      }
      let fileSize = 0.5
      if (props.bannerItem.size) {
        fileSize = props.bannerItem.size
      }
      const shSize = fileSize * 1024
      const isSize = file.size / 1024 > shSize
      if (isSize) {
        return message.error(`上传的图片不能大于${shSize}kb`)
      }
      // let isSizes = false
      // isSizes = await isSizeList(
      //   file,
      //   props.bannerItem.width / props.bannerItem.height
      // ).catch(() => {
      //   isSizes = false
      // })
      // if (!isSizes) {
      //   return message.error('图片比例不正确')
      // }
      handleUpload(file)
      return Promise.reject()
    }
    const delImg = () => {
      console.log('删除')
      emit('removeImg')
    }
    watch(
      () => props.bannerItem.defaultUrl,
      val => {
        state.imageUrl = val
      },
      {
        deep: true
      }
    )
    return {
      ...toRefs(state),
      beforeUpload,
      delImg
    }
  }
}
</script>
<style scoped lang="scss">
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.msg {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
}

.img-wrapper {
  position: relative;
  .img {
    width: 100%;
  }
  .hover-img {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
  }
  &:hover .hover-img {
    display: flex;
    background-color: rgba(0, 0, 0, 0.45);
    align-items: center;
    justify-content: center;
  }
}
</style>
